import React from "react";
import { Col, message, Row, Spin } from 'antd';
import "./EntGroup.css";
import CartTable from "./CartTable/CartTable";
import { useState, useEffect } from "react";
import { TitleSearch } from "components/SearchWidget/TitleSearch";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import { showEntGroupDialog } from "./EntGroupDialog/showEntGroupDialog";
import { apiCreateEnt } from "services/entService";

function EntGroup(props) {
    const { dataList, RemoveEntAction, ownCommonData } = props;
    const [searchList, setSearchList] = useState([]);
    const [totalBudget, setTotalBudget] = useState(0);
    const [isBusy, setIsBusy] = useState(false);

    useEffect(() => {
        setSearchList(dataList)
        getTotalBudget()
    }, [dataList]);

    const handleSearch = (searchText) => {
        const tmpList = dataList.filter((info) => info.name.toLowerCase().includes(searchText.toLowerCase()))
        setSearchList([...tmpList])
    };
    const handleChange = (event) => {
        if (event.target.value === "") {
            setSearchList(dataList)
        }
        else {
            handleSearch(event.target.value)
        }
    };
    const getTotalBudget = () => {
        let total_buget = 0
        for (let i = 0; i < dataList.length; i++) {
            total_buget = parseFloat(total_buget) + parseFloat(dataList[i].total_price)
        }
        setTotalBudget(total_buget)
    }
    const submitEnt = async () => {
        if (dataList.length == 0) {
            message.error("Please Add Ent Item!")
            return
        }
        var res = await showEntGroupDialog({
            totalBudget: totalBudget,
        });
        if (res == null) return;
        let data = { author_name: res.entInfo['author_name'], reason: res.entInfo['reason'], totalBudget: totalBudget, cartList: dataList }
        setIsBusy(true);
        apiCreateEnt(data)
            .then((data) => {
                setIsBusy(false);
                message.success("Successfully Submitted!")
            })
            .catch((err) => {
                message.error(err)
                setIsBusy(false);
            });
    }
    return (
        <div>
            <Spin spinning={isBusy}>

                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                        <TitleSearch
                            onSearch={handleSearch}
                            onChange={handleChange}
                            onPressEnter={handleSearch}
                        />
                    </Col>
                    <Col xs={23} sm={23} md={23} lg={23} xl={11} >
                        <Row gutter={[16, 16]} justify="end">
                            <span style={{ margin: 10 }}>Total Ent Cost : $ {parseFloat(totalBudget).toFixed(2)}</span>
                            <CommonButton
                                customClass={"cart-pay-basic-unit-add-button"}
                                onClick={() => {
                                    submitEnt();
                                }}>
                                    Submit
                            </CommonButton>
                        </Row>
                    </Col>

                </Row>

                <div style={{ marginTop: 20 }}>
                    <CartTable
                        dataList={searchList}
                        RemoveEntAction={RemoveEntAction}
                        ownCommonData={ownCommonData}
                    />
                </div>
            </Spin>
        </div>
    );
}

export default EntGroup;
